import { createUseStyles } from 'react-jss';
import { colors } from '@insurancemenu/imenu-components-lib';
import { ComponentStylesProps } from '@insurancemenu/imenu-components-lib/dist/types/global';
import { TABLE_HEADER_BG_COLOR } from '@insurancemenu/imenu-components-lib/dist/components/tables/utils/constants';

export interface PlanRateCapProps {
  periodElementsAmount: number;
}

const styles: ComponentStylesProps<PlanRateCapProps> = {
  newRateCapWrapper: {
    display: 'flex',
    flexDirection: 'row',
    position: 'relative',
    marginBottom: '3rem',
  },
  planAvailabilityWrapper: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    marginBottom: '3rem',
  },
  title: {
    width: '22.4rem',
    font: { weight: 700, size: '1.6rem', lineHeight: '2.4rem' },
    color: colors.neutral[900],
    margin: [0],
  },
  datePickerWrapper: {
    display: 'flex',
    flexDirection: 'row',
  },
  dateInput: {
    '&:not(:last-child)': {
      marginRight: '3rem',
    },
  },
  rateCapActionsSection: {
    display: 'flex',
    flexDirection: 'row',
    paddingBottom: '3rem',
    width: '65%',
    justifyContent: 'space-between',
  },
  rateCapActionButton: {
    textTransform: 'uppercase',
    paddingLeft: 0,
    fontWeight: 700,
    marginRight: '3rem',
  },
  rateCapPeriodsCapsTableWrapper: {
    border: `0.1rem solid ${colors.neutral[300]}`,
    borderRadius: '1rem',
    marginTop: '3rem',
    marginBottom: '3rem',
    overflowX: 'auto',
    width: '65%',
  },
  rateCapPeriodsTableHeader: {
    boxSizing: 'border-box',
  },
  rateCapPeriodsTableHeading: {
    width: '5rem',
    padding: '1.6rem 0rem',
    backgroundColor: TABLE_HEADER_BG_COLOR,
    '&:first-child': {
      paddingLeft: '2.4rem',
    },
    '&:last-child': {
      width: '25%',
      paddingRight: '2.4rem',
    },
  },
  rateCapPeriodsTableBody: ({ periodElementsAmount }) => ({
    height: `${periodElementsAmount * 6}rem`,
    boxSizing: 'border-box',
  }),
  rateCapPeriodsTableRow: {
    borderBottom: `1px solid ${colors.neutral[300]}`,
    '&:last-of-type': {
      borderBottom: 'none',
    },
  },
  rateCapPeriodsTableCell: {
    font: { size: '1.6rem', lineHeight: '2.4rem' },
    color: colors.neutral[900],
    letterSpacing: '0.02rem',
    padding: '1.6rem 1rem',
    '&:first-child': {
      paddingLeft: '2.4rem',
    },
    '&:last-child': {
      width: '25%',
      paddingRight: '2.4rem',
    },
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
